import { round } from 'lodash';
import { labelAreaHeight, VALUE_TO_LABEL_GAP } from './constants';

const getFundValueBridgeXAxisHeight = () =>
  round(VALUE_TO_LABEL_GAP + labelAreaHeight, 2);

export default getFundValueBridgeXAxisHeight;
